import React from 'react';
import { lang } from 'lang';
import { ScrollView, ListItem, Scene, AppHeader, Confirm } from 'core';
import { isMVP } from 'constants';

import { IcoAccount, IcoSupport, IcoSuggestions, IcoDevices, IcoLogout } from 'icons';

import * as actions from 'actions';

const SettingsList = ({ isSelected }) => (
  <Scene>
    <AppHeader show_connecting title={lang.SETTINGS} />
    <ScrollView contentContainerStyle={{ backgroundColor: 'white' }}>
      <ListItem selected={isSelected.account} title={lang.ACCOUNT} icon={IcoAccount} onPress={actions.selectAccount} />
      <ListItem selected={isSelected.support} title={lang.SUPPORT} icon={IcoSupport} onPress={actions.selectSupport} />
      {isMVP ? null : <ListItem selected={isSelected.suggestions} title={lang.SUGGESTIONS} icon={IcoSuggestions} onPress={actions.selectSuggestions} />}
      <ListItem selected={isSelected.devices} title={lang.DEVICES} icon={IcoDevices} onPress={actions.selectDevices} />
      <ListItem title={lang.LOG_OUT} icon={IcoLogout} onPress={() => Confirm(lang.LOG_OUT_MESSAGE, actions.clickLogout, lang.YES)} />
    </ScrollView>
  </Scene>
);
export default SettingsList;



// WEBPACK FOOTER //
// ./src/components/left/settings_list.js